export function hasFlag(value: number | undefined, flag: number): boolean {
    if (value === undefined) return false;
    return (value & flag) === flag;
}
